/**
 * civic-champs-shared imports `@aws-amplify/core/lib/Logger` (Amplify v4 path). v6 only exports
 * ConsoleLogger from `@aws-amplify/core`. Webpack aliases the legacy path here for onboarding.
 */
export { ConsoleLogger } from '@aws-amplify/core'

/** v4 `LOG_TYPE` surface for shared `requestWithRetry` (includes lowercase `.error` fallback). */
export const LOG_TYPE = {
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARN: 'WARN',
  VERBOSE: 'VERBOSE',
  error: 'ERROR',
}
